import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { SearchLeadService } from './search-lead.service';
@Component({
  selector: 'app-search-lead',
  templateUrl: './search-lead.component.html',
  styleUrls: ['./search-lead.component.scss']
})
export class SearchLeadComponent implements OnInit {
  isLoading: Subject<boolean> = new Subject<boolean>();
  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  displayedColumns: string[] = [
    "date",
    "first_name",
    "email",
    "phone",
    'current_stage.stage',
    // "status",
    "action",
  ];
  private subscription!: Subscription;
  searchKey:any = ''
  constructor(public dialog: MatDialog, private searchLeadService: SearchLeadService) {
    this.subscription = this.searchLeadService.currentData.subscribe((res: any) => {
      if (res) {
        this.searchKey = res;
        this.pageNumber = 1;
        this.pageLimit = 10;
        this.getLead();
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnInit() {
  }

  getLead() {
    let queryParams: any = 'page=' + this.pageNumber + '&limit=' + this.pageLimit

    if (this.searchKey) {
      queryParams += '&search=' + this.searchKey;
    }

    this.isLoading = new BehaviorSubject<boolean>(true);
    this.searchLeadService.getLead(queryParams).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data.list
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        setTimeout(() => {
          this.paginator.length = responseData?.data?.overview?.total
          this.paginator.pageIndex = this.pageNumber - 1
        }, 100)
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  pageNumber: any = 1
  pageLimit: any = 10
  pageHandler(event: any) {
    this.pageLimit = event.pageSize;
    this.pageNumber = event.pageIndex + 1;
    this.getLead();
  }
}
